import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { HostedInput } from '@deseretbook/react-ui'

/**
 * Braintree specific wrapper of the `HostedInput`. Allows Braintree hosted fields
 * to mimic the styling of traditional inputs.
 */
class BraintreeInput extends Component {
  constructor() {
    super()

    this.state = {
      isPristine: true,
    }
  }

  /**
   * Determines if the BraintreeInput should be considered pristine or not based
   * on how props change.
   */
  static getDerivedStateFromProps({ field }, { propsIsFocused, propsIsEmpty, isPristine }) {
    const focusChanged = propsIsFocused !== field.isFocused
    const valueChanged = propsIsEmpty !== field.isEmpty
    const outOfFocus = !field.isFocused && propsIsFocused
    const isInitialized = typeof propsIsFocused === 'boolean'

    if (focusChanged || valueChanged) {
      return {
        propsIsFocused: field.isFocused,
        propsIsEmpty: field.isEmpty,
        isPristine: !isInitialized,
      }
    }

    return null
  }

  render() {
    const { field, ...rest } = this.props
    const { isPristine } = this.state

    // invalid unlessthe user is entering data for the first time and it is potentially valid
    const isInvalid = !isPristine
      && !field.isValid
      && !(field.isFocused && field.isPotentiallyValid)

    let hint = null

    if (isInvalid) {
      hint = field.isEmpty
        ? 'Value is required.'
        : 'Value is invalid.'
    }

    return (
      <HostedInput
        isEmpty={field.isEmpty}
        isValid={field.isValid}
        isInvalid={isInvalid}
        isFocused={field.isFocused}
        hint={hint}
        {...rest}
      />
    )
  }
}

BraintreeInput.propTypes = {
  // Hosted field data.
  field: PropTypes.object,
}

BraintreeInput.defaultProps = {
  field: {},
}

export default BraintreeInput
